import styles from "./info-box-wrapper.module.less";

export type TInfoBoxWrapperProps = {
  children?: React.ReactNode;
  className?: string;
};

export const InfoBoxWrapper = ({ children, className }: TInfoBoxWrapperProps) => {
  return <div className={[styles.wrapper, className ?? ""].join(" ")}>{children}</div>;
};

export default InfoBoxWrapper;
